import { Component, OnInit } from '@angular/core';
import { Project } from 'src/app/models/Project';
import { ProjectsService } from 'src/app/services/projects.service';
import { ModalController, PopoverController, AlertController } from '@ionic/angular';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { ViewProjectInfoModalPage } from 'src/app/modals/view-project-info-modal/view-project-info-modal.page';
import { ApiExportService } from 'src/app/api-services/export.api.service';
import { ModalService } from 'src/app/services/modal.service';
import { MessagesService } from 'src/app/services/messages.service';
import { CustomerUsageService } from 'src/app/services/customer-usage.service';
import { Router } from '@angular/router';
import { CryptoService } from 'src/app/services/crypto.service';
import { AutoSaveService } from 'src/app/services/auto-save.service';
import { StorageService } from 'src/app/services/storageService.service';

@Component({
  selector: 'app-project-menu-popover',
  templateUrl: './project-menu-popover.component.html',
  styleUrls: ['./project-menu-popover.component.scss'],
})
export class ProjectMenuPopoverComponent implements OnInit {

  public project: Project;
  public isModalOpen: boolean = false;

  constructor(
    public projectService: ProjectsService,
    public modalService: ModalService,
    public modalController: ModalController,
    public unfocusService: UnfocusElementService,
    public popoverController: PopoverController,
    public exportApiService: ApiExportService,
    public messagesService: MessagesService,
    public customerUsageService: CustomerUsageService,
    public alertController: AlertController,
    public router: Router,
    public cryptoService: CryptoService,
    public autoSaveService: AutoSaveService,
    public storageService: StorageService
  ) { }

  ngOnInit() { }

  async editProject(event) {
    this.unfocusService.unfocus(event);
    this.popoverController.dismiss();
    this.projectService.presentUpsertProject(this.project, false);
  }

  async copyProject(event) {
    this.unfocusService.unfocus(event);
    this.popoverController.dismiss();
    this.projectService.copyProject(this.project);
  }

  async deleteProject(event) {
    this.unfocusService.unfocus(event);
    this.popoverController.dismiss();
    this.projectService.deleteProject(this.project);
  }

  async downloadProjectReport(event) {
    this.unfocusService.unfocus(event);
    this.popoverController.dismiss();

    await this.messagesService.presentLoadingWindow('Validating reporting credits...');
    let lrsCredits: number = await this.customerUsageService.getLRSCreditsUsagePercentage();
    await this.messagesService.loadingWindow.dismiss();

    if (lrsCredits >= 100) {
      let confirmationResult = await this.downloadProjectReportAlert();
      if (confirmationResult === 'buy') {
        if (this.cryptoService.decryptData(this.storageService.getItem("login_r")) == "ad") 
          this.router.navigateByUrl('/my-account');
        else 
          this.router.navigateByUrl('/contact-admin');
      }
      return;
    }

    this.exportApiService.exportXAPIReport(this.project).then(x => {
      if(x == true){
        this.messagesService.presentToast("XAPI report downloaded successfully!", "success", "Projects");
      }
    });
  }

  async exportProject(event) {
    this.unfocusService.unfocus(event);
    this.popoverController.dismiss();

    let projectScenes = await this.projectService.getProjectScenes(this.project.projectId);

    if(projectScenes.length > 0){
      this.autoSaveService.saving = false;
      this.modalService.presentExportProjectWizard(this.project);
    }else{
      this.presentNoScenesAlert();
    }

  }

  async showProjectInformation(event) {
    this.unfocusService.unfocus(event);

    if (this.isModalOpen === true) return;
    this.isModalOpen = true;

    this.popoverController.dismiss();
    const modal = await this.modalController.create({
      component: ViewProjectInfoModalPage,
      id: 'project-view-modal',
      componentProps: {
        "project": this.project
      }
    });

    modal.onDidDismiss().then(() => {
      this.isModalOpen = false;
    });

    return await modal.present();
  }

  downloadProjectReportAlert(): Promise<string> {
    return new Promise<string>(async (resolve) => {
      let message: string = `You have used all your reporting credits. Do you want to buy more reporting credits?`;

      const alert = await this.alertController.create({
        header: 'Download XAPI Report',
        message: message,
        cssClass: 'leave-alert',
        backdropDismiss: true,
        buttons: [{
          text: 'Go To Account Page',
          cssClass: 'leave-button',
          handler: () => {
            resolve('buy');
          }
        }]
      });

      alert.onDidDismiss().then((eventDetail) => {
        if (eventDetail.role === 'backdrop') {
          resolve('');
        }
      });

      await alert.present();
    });
  }

  async presentNoScenesAlert(){
    const alert = await this.alertController.create({
      header: 'No Scenes Found',
      message: "Please add scenes to your project before attempting to export.",
      cssClass: 'ok-alert',
      buttons: [{
        text: 'Ok',
        cssClass: 'ok-button',
        handler: () => {
        }
      }]
    });
    await alert.present();    
  }

}
